import {Panes, TextField} from '@management-ui/core';
import {UploadField} from '@management-ui/upload';
import React from 'react';

const Fields = ({image = {}, prefix = ''}) => {
  return (
    <Panes
      entity={image}
      prefix={prefix}
      panes={[
        {
          title: 'Image Details',
          fields: [
            <TextField
              name="title"
              prefix={prefix}
              label="Title"
              rules={{required: 'Please enter a title for this image'}}
            />,
            <UploadField
              name="image"
              prefix={prefix}
              label="Drop an image here or click to select from your computer"
              rules={{required: 'Please select an image to upload'}}
              types=".jpg,.jpeg,.png"
            />
          ]
        }
      ]}
      title=""/>
  );
};

export default Fields;
